import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Start earlier than the viewport bottom so short footer content still triggers
// while scrolling down on desktop (before reaching max scroll).
const VIEWPORT_START_OFFSET = 200;

/** Keep `start` in sync with scrollStartAlreadyMet() or visible content can sit between the two thresholds (desktop). */
function scrollTriggerDefaults() {
	return {
		start: `top bottom+=${VIEWPORT_START_OFFSET}px`,
		once: true,
		invalidateOnRefresh: true,
	};
}
const IN_VIEW_LOAD_DELAY = 1.5;

/** True when `el` has already passed the ScrollTrigger start line (would fire immediately on load). */
function scrollStartAlreadyMet(el) {
	const line = window.innerHeight + VIEWPORT_START_OFFSET;
	return el.getBoundingClientRect().top <= line;
}

/** ScrollTrigger ignores `delay` on tweens; use timeline start position instead. */
function entrancePosition(triggerEl) {
	return scrollStartAlreadyMet(triggerEl) ? IN_VIEW_LOAD_DELAY : 0;
}

export default class ResultsFooter {
	constructor(block) {
		this.block = block;
		this.title = this.block.querySelector(".block-title");
		this.heart = this.block.querySelector("img");

		this.setStartingPositions();
		this.animateIn();
	}

	setStartingPositions() {
		if (this.title) {
			gsap.set(this.title, { opacity: 0, x: -64 });
		}
		if (this.heart) {
			gsap.set(this.heart, { opacity: 0, y: 128 });
		}
	}

	animateIn() {
		if (this.title) {
			// On larger/taller viewports the title can also miss the start line before max scroll.
			// Use the block as trigger so both footer animations fire consistently.
			const pos = entrancePosition(this.block);
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: this.block,
					start: scrollTriggerDefaults().start,
					once: true,
					invalidateOnRefresh: true,
				},
			});
			tl.to(
				this.title,
				{
					opacity: 1,
					x: 0,
					duration: 0.5,
					ease: "power2.out",
				},
				pos
			);
		}

		if (this.heart) {
			// Heart is the lowest thing in the footer; at max scroll its top often never crosses
			// `top bottom-=50px`, so ScrollTrigger never fires. Drive the tween from the block instead.
			const pos = entrancePosition(this.block);
			gsap
				.timeline({
					scrollTrigger: {
						trigger: this.block,
						start: scrollTriggerDefaults().start,
						once: true,
						invalidateOnRefresh: true,
					},
				})
				.to(
					this.heart,
					{
						opacity: 1,
						y: 0,
						duration: 2,
						ease: "power2.out",
					},
					pos
				);
		}
	}

}
